<template>
    <div id="audio-player">
        <a :href="audioSrc" class="action-btn download-btn" download>
            <span class="iconify" data-icon="akar-icons:download" data-inline="false"></span>
        </a>
        <div class="audio-timer">
            {{duration}}
            /
            {{audioTimer}}
        </div>
        <audio :id="uniqueId" v-on:play="audioDetails(uniqueId)" v-on:ended="audioRefresh(uniqueId)">
            <source :src="audioSrc" type="audio/ogg">
            <source :src="audioSrc" type="audio/mpeg">
        </audio>
        <button v-on:click="audioController(uniqueId,'playBtn')" :id="uniqueId+'icon'" class="action-btn">
            <!--<i class="fa fa-play"  aria-hidden="true"></i>-->
            <span v-if="mode==='play'">
               <span class="iconify" data-icon="akar-icons:play" data-inline="false"></span>
            </span>
            <span v-else>
               <span class="iconify" data-icon="bi:pause-fill" data-inline="false"></span>
            </span>
        </button>
        <button v-on:click="audioController(uniqueId,'reloadBtn')" class="action-btn">
            <!--<i class="fa fa-refresh" aria-hidden="true"></i>-->
            <span>
                <span class="iconify" data-icon="clarity:refresh-line" data-inline="false"></span>
            </span>
        </button>
    </div>
    <div v-bind:class="{ 'expert-comment-time' : side==='admin' , 'user-comment-time' : side==='user' }">
        <span>
             {{createdAt}}

              <span v-if="side==='admin'" class="sender-details">
                    /
               <span v-if="relatedAdmin.role === 'Deputy'">
                   معاون
               </span>
               <span v-else-if="relatedAdmin.role === 'DepartmentHead'">
                   مدیر گروه
               </span>
               <span v-else-if="relatedAdmin.role === 'GeneralManager'">
                   مدیر دپارتمان
               </span>
               <span v-else-if="relatedAdmin.role === 'Expert'">
               <span v-if="relatedAdmin.type === 'Expert_Client'">
                   کارشناس اصلی
               </span>
               <span v-else-if="relatedAdmin.type === 'AlongExpert_Client'">
                  کارشناس همراه
               </span>
               <span v-else>
                   کارشناس
               </span>
               </span>
               <span v-else>
                  مدیر کل
               </span>
            </span>
        </span>
        <button class="status-btn" v-if="side==='user'">
        <span v-if="currentStatus==='sent'">
        <span class="iconify" data-icon="bi:check" data-inline="false"></span>
        </span>
            <span class="loading" v-else-if="currentStatus==='send'">
             <span class="iconify" data-icon="uil:spinner-alt" data-inline="false"></span>
            </span>
            <span v-else>
        <span class="iconify" data-icon="ant-design:warning-outlined" data-inline="false"></span>
        </span>
        </button>
    </div>
</template>
<script>
    import axios from 'axios'
    //let mode='play';
    export default {
        name: "AudioPlayer",
        data() {
            return {
                audioTimer: '00 : 00',
                timerInterval: null,
                duration: '00 : 00',
                currentStatus: 'sent',
                mode: 'play'
            }
        },
        props: {
            audioSrc: String,
            uniqueId: String,
            fileType: String,
            currentDate: String,
            status: String,
            submitKey: Number,
            filePreviousName: String,
            currentUserDetails: Object,
            fileContent: File,
            side: String,
            createdAt: String,
            relatedAdmin: Object
        },
        methods: {
            upload() {
                this.currentStatus = this.status;
                const formData = new FormData();
                formData.append('file', this.fileContent);
                formData.append('file_previous_name', this.filePreviousName);
                //formData.append('enctype', "multipart/form-data");

                //console.log(this.fileContent);

                axios.post('/api/userDashboard/chatFileStore', formData, {
                    headers:
                        {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                            "Content-Type": "multipart/form-data",
                        }
                }).then(response => {
                    console.log(response.data, 'here');
                    this.currentStatus = 'sent';
                }).catch(error => {
                    this.currentStatus = 'error';
                    console.log(error);
                });


                // this.currentStatus = this.status;
                // axios.post('/api/userDashboard/chatTextStore',
                //     {
                //         data: {
                //             text: 'salam'
                //         }
                //     }, {
                //         headers:
                //             {
                //                 "Authorization": `Bearer ${localStorage.getItem('token')}`,
                //             }
                //     }).then(response => {
                //     this.currentStatus = 'sent';
                //     console.log(response.data)
                // }).catch(error => {
                //     this.currentStatus = 'error';
                //     console.log(error);
                // });


            },
            audioController(id, btnType) {
                let audio = document.getElementById(id);
                if (btnType === 'reloadBtn') {
                    document.getElementById(id + 'icon').classList.remove('fa-play');
                    document.getElementById(id + 'icon').classList.add('fa-pause');
                    audio.currentTime = 0;
                    audio.play();
                    this.mode = 'pause';
                    this.timerInterval = setInterval(() => {
                        let mins = Math.floor(audio.currentTime / 60);
                        let secs = Math.floor(audio.currentTime % 60);
                        if (secs < 10) {
                            secs = '0' + String(secs);
                        }
                        if (mins < 10) {
                            mins = '0' + String(mins);
                        }
                        this.audioTimer = secs + ' : ' + mins;
                    }, 10);
                } else {
                    if (this.mode === 'play') {
                        document.getElementById(id + 'icon').classList.remove('fa-play');
                        document.getElementById(id + 'icon').classList.add('fa-pause');
                        audio.play();
                        this.mode = 'pause';
                        this.timerInterval = setInterval(() => {
                            let mins = Math.floor(audio.currentTime / 60);
                            let secs = Math.floor(audio.currentTime % 60);
                            if (secs < 10) {
                                secs = '0' + String(secs);
                            }
                            if (mins < 10) {
                                mins = '0' + String(mins);
                            }
                            this.audioTimer = secs + ' : ' + mins;
                        }, 10);
                    } else {
                        document.getElementById(id + 'icon').classList.remove('fa-pause');
                        document.getElementById(id + 'icon').classList.add('fa-play');
                        audio.pause();
                        clearInterval(this.timerInterval);
                        this.mode = 'play'
                    }
                }


            },
            audioDetails(id) {
                if (document.getElementById(id)) {
                    let sec_num = parseInt(document.getElementById(id).duration, 10); // don't forget the second param
                    let hours = Math.floor(sec_num / 3600);
                    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                    let seconds = sec_num - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = "0" + hours;
                    }
                    if (minutes < 10) {
                        minutes = "0" + minutes;
                    }
                    if (seconds < 10) {
                        seconds = "0" + seconds;
                    }
                    if (isNaN(minutes) === false && isNaN(seconds) === false) {
                        this.duration = seconds + ' : ' + minutes;
                    } else {
                        this.duration = '00 : 00';
                    }
                }
            },
            audioRefresh(id) {
                //let audio = document.getElementById(id);
                document.getElementById(id + 'icon').classList.remove('fa-pause');
                document.getElementById(id + 'icon').classList.add('fa-play');
                clearInterval(this.timerInterval);
                //audio.p();
                this.mode = 'play';
            },
        },
        mounted() {
            let localStorageCurrentDate = localStorage.getItem('currentDate');
            console.log(this.currentDate, 'prop');
            console.log(localStorageCurrentDate, 'local');
            if (this.currentDate === localStorageCurrentDate) {
                this.upload();
            }
        },
        created() {
            this.audioDetails(this.uniqueId);
        },
    }
</script>
<style lang="scss" scoped>
    .expert-comment-time, .user-comment-time {
        display: flex !important;
        opacity: 0.5;
        font-family: IRANSans;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #000000;
        width: 100%;
        height: 30px;
        line-height: 30px;
    }

    .user-comment-time {
        justify-content: flex-end;
    }

    .expert-comment-time {

    }

    .loading {
        -webkit-animation: spin 1s linear infinite;
        -moz-animation: spin 1s linear infinite;
        animation: spin 1s linear infinite;
    }

    @-moz-keyframes spin {
        100% {
            -moz-transform: rotate(360deg);
        }
    }

    @-webkit-keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }


    #audio-player {
        margin-top: 5px;
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        width: max-content;

    }

    .audio-timer {
        float: right;
        height: 25px;
        width: 100px;
        line-height: 25px;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .action-btn {
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        cursor: pointer;
        background: transparent;
        color: black;
        margin: 0;

        span {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .status-btn {
        background: transparent;
        color: black;
        margin: 0;

        span {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
        }
    }

    .download-btn {
        margin: 0 5px 0 5px;
    }
</style>